import React, { useState, useEffect, useRef } from 'react';
// import { appInsights, reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { SelectChangeEvent } from '@mui/material';
import { Checkbox, Button, TextField, MenuItem } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import cn from 'clsx';
import { TextComponent, SelectComponent } from '../uiComponents';
import { EnumerationComponent } from '../gritComponents';
import { AADAttribute } from '../../xmlParsing/interfaces';
import { init_AADAttribute } from '../../xmlParsing/initInterfaces';
import { jsonEditorStyles } from './jsonEditorStyles';
import { useSelector, useDispatch } from 'react-redux';
import { getJSONAADAttributes, setJSONAADAttributes } from '../../store';
import CONSTANTS from '../../constants/constants';
import { OptionProps } from '../../view-models';
import ShowClaimComponent from '../gritComponents/showClaim';

interface AADAttributeComponentProps {
  data: AADAttribute;
  changeHandler: (data: AADAttribute) => void;
}

function JSONAADAttributesComponent({ data, changeHandler }: AADAttributeComponentProps) {
  const initData = useRef<AADAttribute>(data);
  const [modifiedData, setModifiedData] = useState<AADAttribute>(init_AADAttribute());
  const [showPattern, setShowPattern] = useState<string>('');
  const [selectedAttribute, setSelectedAttribute] = useState<string>('');
  const [aadAttributesList, setAadAttributesList] = useState<OptionProps[]>([]);
  const [aadAttributeError, setAadAttributesError] = useState<string>('Should not be empty');
  const classes = jsonEditorStyles();
  const allAADAttributes = useSelector(getJSONAADAttributes);
  const dispatch = useDispatch();

  useEffect(() => {
    setModifiedData(data);
  }, [initData]);

  useEffect(() => {
    if (Object.keys(allAADAttributes).length > 0) {
      const _temp = Object.keys(allAADAttributes)
        .reduce((acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }), [])
        .sort((a: OptionProps, b: OptionProps) => (a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1));
      setAadAttributesList(_temp);
      setSelectedAttribute(_temp[0]['value']);
    }
  }, [allAADAttributes]);

  return (
    <div className={classes.flexRow}>
      <div className={cn(classes.flexCol, classes.flex)}>
        <div>
          <TextComponent
            changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
              if (e.target.value === '') {
                setAadAttributesError('Should not be empty');
              } else if (!/^[a-zA-Z0-9]+[a-zA-Z0-9_-]{0,}$/.test(e.target.value)) {
                setAadAttributesError(
                  'Should begin with an alphabet or number and can contain alphabets, numbers and the following symbols: _ -',
                );
              } else if (
                Object.keys(allAADAttributes).findIndex(
                  (el: string) => el.trim().toLowerCase() === `extension_${e.target.value.trim().toLowerCase()}`,
                ) >= 0
              ) {
                setAadAttributesError('A claimTypeReferenceId exists with the same name');
              } else {
                setAadAttributesError('');
              }
              setModifiedData({ ...modifiedData, id: e.target.value });
            }}
            data={{
              value: modifiedData.id || '',
              label: 'AAD Attribute Name',
              error: !!aadAttributeError,
              helperText: aadAttributeError,
            }}
          />
        </div>
        <div>
          <SelectComponent
            changeHandler={(e: SelectChangeEvent<string>) => {
              setModifiedData({ ...modifiedData, dataType: e.target.value });
            }}
            data={{
              value: modifiedData['dataType'],
              label: 'Data Type',
              options: [
                { label: 'string', value: 'string' },
                { label: 'boolean', value: 'boolean' },
                { label: 'dateTime', value: 'dateTime' },
              ],
            }}
          />
        </div>
        <div>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            onClick={() => {
              setModifiedData(init_AADAttribute());
              setAadAttributesError('Should not be empty');
              modifiedData.id = 'extension_' + modifiedData.id;
              dispatch(setJSONAADAttributes(modifiedData));
            }}
            disabled={!!aadAttributeError}
          >
            Add
          </Button>
        </div>
      </div>
      <div className={cn(classes.flexCol, classes.attributeSection)}>
        {aadAttributesList.length === 0 && <div>There are no attributes</div>}
        {aadAttributesList.length > 0 && (
          <>
            <SelectComponent
              changeHandler={(e: SelectChangeEvent<string>) => {
                setSelectedAttribute(e.target.value);
              }}
              data={{
                value: selectedAttribute,
                label: 'Select Attributes',
                style: { margin: 1, width: 400 },
                options: aadAttributesList,
              }}
            />
            <ShowClaimComponent data={allAADAttributes[selectedAttribute]} />
          </>
        )}
      </div>
    </div>
  );
}

// export default withAITracking(reactPlugin, JSONAADAttributesComponent);
export default JSONAADAttributesComponent;
